import {
  Shield,
  Bug,
  Search,
  AlertTriangle,
  Users,
  Mail,
  Server,
  Globe,
} from "lucide-react";

const skills = [
  { name: "Penetration Testing", icon: Shield, level: 95 },
  { name: "Exploit Development", icon: Bug, level: 90 },
  { name: "Vulnerability Assessment", icon: Search, level: 92 },
  { name: "Risk Analysis", icon: AlertTriangle, level: 88 },
  { name: "Red Team Operations", icon: Users, level: 93 },
  { name: "Phishing Campaigns", icon: Mail, level: 85 },
  { name: "Infrastructure Security", icon: Server, level: 87 },
  { name: "Threat Intelligence", icon: Globe, level: 86 },
];

const Skills = () => {
  return (
    <section id="skills" className="py-24 relative">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="font-mono text-sm text-primary mb-4">
            {">"} skills --list
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Technical <span className="text-primary text-glow">Arsenal</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Years of experience in offensive security, building a comprehensive
            toolkit for identifying and exploiting vulnerabilities.
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto stagger-children">
          {skills.map((skill, index) => (
            <div key={skill.name} className="cyber-card p-6 hover-lift group">
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 rounded-lg bg-primary/10 text-primary group-hover:glow transition-all">
                  <skill.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg">{skill.name}</h3>
                  <span className="text-sm text-muted-foreground font-mono">
                    {skill.level}%
                  </span>
                </div>
              </div>
              <div className="skill-bar">
                <div
                  className="skill-bar-fill"
                  style={{
                    width: `${skill.level}%`,
                    animationDelay: `${index * 0.1}s`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Terminal decoration */}
        <div className="mt-16 max-w-2xl mx-auto cyber-card p-6 font-mono text-sm">
          <div className="flex items-center gap-2 mb-4 text-muted-foreground">
            <div className="w-3 h-3 rounded-full bg-accent" />
            <div className="w-3 h-3 rounded-full bg-yellow-500" />
            <div className="w-3 h-3 rounded-full bg-primary" />
            <span className="ml-2">terminal</span>
          </div>
          <div className="space-y-2 text-muted-foreground">
            <p>
              <span className="text-primary">$</span> nmap -sV --script=vuln
              target.com
            </p>
            <p>
              <span className="text-primary">$</span> msfconsole -x "use
              exploit/multi/handler"
            </p>
            <p>
              <span className="text-primary">$</span> burpsuite
              --project=audit_2026
            </p>
            <p className="text-primary">█</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
